<ng-container *transloco="let t; read: 'inventory.detail.attachments'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="xs12col flex-wrap">
        <div class="xs12col m12col" [hidden]="!('Permissions.InventoryDeviceAttachments.Create' | permission)">
          <div class="fieldsetWrapper margin-bottom-medium attachments">
            <fieldset class="fieldsetContainer flexRow">
              <div class="titleAdd">
                <h2 class="xs12col">{{ t('uploadAttachments') }}</h2>
              </div>
              <span [attr.tooltip]="t('upload.tooltipDocuments')" flow="right" class="tooltipContainer">
                <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
              </span>
              <kendo-upload
                kendoButton
                loadingIndication="/inventoryDevices/uploadInventoryDeviceAttachment"
                (upload)="uploadAttachment($event)"
                [ngClass]="{ 'uploading': vm.isUploading }"
                [batch]="true"
                [restrictions]="restrictions">
                <kendo-upload-messages
                  [dropFilesHere]="t('upload.dropZone')"
                  [select]="vm.isUploading ? '&#x21bb;' : t('upload.button')">
                </kendo-upload-messages>
              </kendo-upload>
            </fieldset>
          </div>
        </div>
        <div class="xs12col m6col">
          <div class="fieldsetWrapper margin-right-small attachments">
            <fieldset class="fieldsetContainer flexRow">
              <div class="titleAdd fullWidth">
                <h2 class="xs12col">{{ t('documents') }}</h2>
              </div>
              <div class="xs12col attachmentWrapper">
                @for (document of vm.documents; track document.id) {
                  <div class="attachmentItem">
                    <a (click)="documentDeletionDialogOpen(document.id)" [hidden]="!('Permissions.InventoryDeviceAttachments.Delete' | permission)" class="deleteIconList"><img src="../../../assets/icons/delete-icon.svg"></a>
                    <a (click)="downloadAttachment(document.id, document.fileName)">{{ document.fileName }}</a>
                  </div>
                }
              </div>
            </fieldset>
          </div>
        </div>
        <div class="xs12col m6col">
          <div class="fieldsetWrapper margin-top-medium-mobile margin-left-small">
            <fieldset class="fieldsetContainer flexRow">
              <div class="titleAdd fullWidth">
                <h2 class="xs12col">{{ t('pictures') }}</h2>
              </div>
              <div class="xs12col attachmentWrapper">
                @for (image of vm.images; track image.id) {
                  <div class="attachmentItem">
                    <a (click)="imageDeletionDialogOpen(image.id)" [hidden]="!('Permissions.InventoryDeviceAttachments.Delete' | permission)" class="deleteIcon"><img src="../../../assets/icons/close-icon.svg"></a>
                    <div class="imageContainer">
                      <img [src]="image.data" class="image" />
                    </div>
                  </div>
                }
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      @if (documentDeletionDialogOpened) {
        <kendo-dialog
          title="{{t('confirmDeletion')}}"
          (close)="documentDeletionDialogClose('cancel')"
          [minWidth]="250"
          [width]="450">
          <p style="margin: 30px; text-align: center;">
            {{t('documentDeletionMessage')}}
          </p>
          <kendo-dialog-actions>
            <button kendoButton (click)="documentDeletionDialogClose('cancel')">{{ tGlobal('cancel') }}</button>
            <button kendoButton (click)="documentDeletionDialogClose('delete')" themeColor="primary">{{ tGlobal('delete') }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
      @if (imageDeletionDialogOpened) {
        <kendo-dialog
          title="{{t('confirmDeletion')}}"
          (close)="imageDeletionDialogClose('cancel')"
          [minWidth]="250"
          [width]="450">
          <p style="margin: 30px; text-align: center;">
            {{t('imageDeletionMessage')}}
          </p>
          <kendo-dialog-actions>
            <button kendoButton (click)="imageDeletionDialogClose('cancel')">{{ tGlobal('cancel') }}</button>
            <button kendoButton (click)="imageDeletionDialogClose('delete')" themeColor="primary">{{ tGlobal('delete') }}
            </button>
          </kendo-dialog-actions>
        </kendo-dialog>
      }
    }
  </ng-container>
</ng-container>